var _style, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#0052B4;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.4,200.3h-64.3L256,144.7l-32.1,55.7h-64.3l32.1,55.7l-32.1,55.7h64.3l32.1,55.7l32.1-55.7h64.3L320.3,256 L352.4,200.3z M295.5,256l-19.7,34.2h-39.5L216.5,256l19.7-34.2h39.5L295.5,256z M256,187.6l7.3,12.7h-14.7L256,187.6z  M196.8,221.8h14.7l-7.3,12.7L196.8,221.8z M196.8,290.2l7.3-12.7l7.3,12.7H196.8z M256,324.4l-7.3-12.7h14.7L256,324.4z  M315.2,290.2h-14.7l7.3-12.7L315.2,290.2z M300.5,221.8h14.7l-7.3,12.7L300.5,221.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.4,55.7H96.6c-23.4,18.6-43.4,41.2-59.1,66.8h436.9C458.8,96.9,438.7,74.3,415.4,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.6,456.3h318.7c23.4-18.6,43.4-41.2,59.1-66.8H37.6C53.2,415.1,73.3,437.7,96.6,456.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIl);
export default __webpack_public_path__ + "static/media/il.8c9826664b539a4f8406a31c3826d7c8.svg";
export { ForwardRef as ReactComponent };